export default {
  path: '/matchlist',
  title: '赛事中心',
  icon: 'flask',
  children: (pre => [
    { path: `${pre}/match/index`, title: '赛事中心', icon: 'iconoperate_pop_match', auth_token: 'xg:matchlist:index' },
  ])('/matchlist')
}
